import { useRef, useState } from "react";

export default function Filter({
  records,
  search,
  totalDeposit,
  bankWiseDepositList,
}) {
  const searchRef = useRef();

  const formatCurrency = (num) => {
    return Number(num || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  };

  const total = Number(totalDeposit || 0);

  const [searchuser, setSearchUser] = useState("");

  return (
    <div className="filter px-4">
      <div className="filterleft">
        <button className={"NavLinkBtn hover marginright unselectlink"}>
          Records : {records}
        </button>
        <button className="NavLinkBtn hover white"
        style={{
          backgroundColor : "#399918"
        }}
        >
          Total : ₹ {formatCurrency(total)}
        </button>
      </div>
      {/* 🔹 Bank Wise Section */}
      {bankWiseDepositList?.length > 0 && (
        <div className="flex gap-3 overflow-x-auto scrollbar-hide">
          {bankWiseDepositList.map((bank, index) => {
            const bankTotal = Number(bank.total_deposit || 0);
            return (
              <button key={index} className="NavLinkBtn hover selectlink">
                BANK : {bank.bank_name}({bank.account_number}) : ₹{" "}
                {formatCurrency(bankTotal)}
              </button>
            );
          })}
        </div>
      )}
      <div className="filterright">
        <div className="margin-right">
          <input
            ref={searchRef}
            type="text"
            name="search"
            id="search"
            autoComplete="new-password"
            placeholder="Search Acc/Name/User"
            class="input bg-[var(--background)] border-2 h-7 border-[var(--hover)] text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white "
            value={searchuser}
            onChange={(e) => {
              setSearchUser(e.target.value);
              search(e.target.value);
            }}
          />
        </div>
      </div>
    </div>
  );
}
